import { createSlice } from '@reduxjs/toolkit';
import { searchQuery } from 'utils';

const initialState = {
  language: {
    get lngCode() { return searchQuery('lang') || searchQuery('l') || navigator?.language?.split('-')[0]; },
    forceDefault: true
  },
  recaptchaState: undefined,
  popupState: {
    open: false,
    button: false
  }
};

const generalSlice = createSlice({
  name: 'general',
  initialState: { ...initialState },
  reducers: {
    resetGeneral() { return { ...initialState } },
    languageSet(state, { payload }) { state.language = payload },
    popupActiveSet(state, { payload }) { state.popupState = payload },
    recaptchaStateSet(state, { payload }) { state.recaptchaState = payload },
  }
});

export const { resetGeneral, popupActiveSet, languageSet, recaptchaStateSet } = generalSlice.actions;
export default generalSlice.reducer;

